import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/goalsSagas";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";

export const ModuleViewFilter = () => {
  const dispatch = useDispatch();
  const selectedModuleView = useSelector((state) => state.goals.selectedModuleView);
  const moduleViewOptions = useSelector((state) => state.goals.moduleViewOptions);
  const topGoalsLoading = useSelector((state) => state.goals.topGoalsLoading);

  return topGoalsLoading ? (
    <button className="picky__input">
      <LoadingAnimation uiLoader />
    </button>
  ) : (
    <MultiSelectDropdown
      options={moduleViewOptions}
      selectedFilters={selectedModuleView}
      placeholder="Select Range"
      numberDisplayed={0}
      multiple={false}
      keepOpen={false}
      includeFilter={false}
      onSelectChange={(data) => {
        if (selectedModuleView.id !== data.id) {
          dispatch(actionCreators.updateModuleView(data));
        }
      }}
    />
  );
};
